import type { MaybeRef } from "vue"
import type { MetaV1, ServerResponseV1 } from "@/http"
import type { ISlideshowConfigResponse, ISlideshowListExtensions } from "@/types"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"
import { SlideshowConfig } from "@/models"

export async function listSlideshowConfigs(eventVaultId?: number) {
  const endpoint = `/${eventVaultId}/slideshow`

  const response = await v1.get<ServerResponseV1<ISlideshowConfigResponse[], MetaV1<ISlideshowListExtensions>>>(endpoint)

  return {
    slideshows: response.data.data?.map(config => SlideshowConfig.fromResponse(config)) ?? [],
    slideshowVideosEnabled: response.data.meta?.extensions?.slideshowVideosEnabled ?? false,
  }
}

const LIST_SLIDESHOW_CONFIGS = "listSlideshowConfigs"

export function useListSlideshowConfigs(eventVaultId?: MaybeRef<number | undefined>) {
  return useQuery({
    queryKey: [LIST_SLIDESHOW_CONFIGS, eventVaultId],
    queryFn: () => listSlideshowConfigs(toValue(eventVaultId)),
    enabled: !!toValue(eventVaultId),
  })
}
